import { Tooltip } from "@mui/material";

/**
 * Neutral info affordance: a small "ⓘ" circle that reveals a definition on
 * hover. Mirrors WarningIconWithTooltip (same MUI Tooltip convention) but for
 * clarifying ambiguous labels rather than flagging problems. Sized h-4 w-4 to
 * sit inline next to a text-sm form label.
 */
const InfoIconWithTooltip = ({ message, className = "" }: { message: string; className?: string }) => {
  return (
    <Tooltip title={message} placement="top">
      <span className={`inline-flex cursor-help text-gray-400 ${className}`}>
        <svg
          xmlns="http://www.w3.org/2000/svg"
          fill="none"
          viewBox="0 0 24 24"
          stroke="currentColor"
          strokeWidth="1.5"
          className="h-4 w-4"
        >
          <circle cx="12" cy="12" r="9" />
          <path strokeLinecap="round" strokeLinejoin="round" d="M12 10.5v5.5m0-8h.01" />
        </svg>
      </span>
    </Tooltip>
  );
};

export default InfoIconWithTooltip;
